// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"79":"6595d423","127":"98d59710","168":"0a0940fd","231":"5461efd4","234":"c32dc411","554":"a1015a63","967":"626bf276"}[chunkId] + ".css";
};